import React, { useEffect, useState } from "react";
import "../assets/css/custom.css";
import "../assets/css/client.css";
import "../assets/css/font-awesome.css";
import "../assets/css/sweetalert.css";
import "../assets/css/bootstrap.min.css";
import "../assets/css/steps.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrashCan, faPenToSquare} from "@fortawesome/free-solid-svg-icons";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";

import {commonAPI} from "../services/CommonAPIService"
import {ErrorSource} from '../common/constants'
import GateIcon from '../assets/img/no-gate.png'
import FrIcon from '../assets/img/fr.png'
import QrIcon from '../assets/img/qr.png'
import TagIcon from '../assets/img/tag.png'
import Select from 'react-select';
import { ToastContainer, toast } from 'react-toastify';

function Gate() {
  const [show, setShow] = useState(false);
  const [GateList, setGateList] = useState([]);
  const [GateName, setGateName] = useState("");
  const [GateIp, setGateIp] = useState("");
  const [GateId, setGateID] = useState("");
  const [PortNumber, setPortNumber] = useState("");
  const [IsMainGate, setIsMainGate] = useState(true);
  const [Pin, setPin] = useState("");
  const [BarrierOperate, setBarrierOperate] = useState("");
  const [SignalLight, setSignalLight] = useState("");
  const [AccessType, setAccessType] = useState("Public");
  const [GateType, setGateType] = useState("Entry");
  const [GateSubType, setGateSubType] = useState("4WHEELER");
  const [IsOperable, setIsOperable] = useState(true);
  const [IsCascadable, setIsCascadable] = useState(true);
  const [Loading, setLoading] = useState(false);
  const [UserData, setUserData] = useState("");
  const [AddGateBtn, setAddGateBtn] = useState(false);
  const [UpdateGateBtn, setUpdateGateBtn] = useState(false);
  const [BuildingList, setBuildingList] = useState("");
  const [BuildingId, setBuildingId] = useState("");
  const [DeleteShow, setDeleteShow] = useState(false);
  const [SelectedGateId, setSelectedGateId] = useState("");
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [MultiValue, setMultiValue] = useState(0);
  const [AccessControl, setAccessControl] = useState([]);
  const [optionsAccess, setOptionsAccess] = useState([]);
  const [Accessenable, setAccessenable] = useState("");
  const [AntiPassbackEnable, setAntiPassbackEnable] = useState("");
  const [GroupGateList, setGroupGateList] = useState([]);
  const [GroupGateId, setGroupGateId] = useState("");
  console.log("IsMainGate", Accessenable)

  const setInputValue = (item) => {
    setShow(true);
    console.log("item", item)
    setAddGateBtn(false);
    setUpdateGateBtn(true);
    setGateName(item?.gateName);
    setGateID(item.gateId)
    setGateIp(item?.gateIP);
    setPortNumber(item?.portNumber);
    setIsMainGate(item?.isMainGate);
    setPin(item?.pin);
    setBarrierOperate(item?.barrierOperateTime);
    setSignalLight(item?.signalLightTime);
    setAccessType(item?.accessType);
    setGateType(item?.gateType);
    setGateSubType(item?.gateSubType);
    setIsCascadable(item?.isCascadable);
    setIsOperable(item?.isOperable)
    setMultiValue(item?.accessControlPrimeFactor)
    setGroupGateId(item?.levelId)
  };
 
  const openCreateModal = () => {
    if(BuildingId){
      setShow(true);
      setAddGateBtn(true);
      setUpdateGateBtn(false);
      setGateName("");
      setGateIp("");
      setPortNumber("");
      setPin("");
      setIsMainGate(true)
      setBarrierOperate("");
      setSignalLight("");
      setAccessType("Public");
      setGateType("Entry");
      setGateSubType("4WHEELER");
      setIsCascadable(true);
      setIsOperable(true);
      setSelectedOptions([])
      setGroupGateId("")
    }else{
      toast.warning("Please select Building");
    }  
  };

 

  const GetBuildingList = async () => {
    const auth = localStorage.getItem("primeProductCode");
        const ProductfactorKey = JSON.parse(auth);
        const endPointVariableKey = {
            ProductId: ProductfactorKey?.primeProductCode,
        }

    try {
        setLoading(true);
        let response = await commonAPI("BuildingLite", undefined, endPointVariableKey)
        console.log("Table Building", response.data)
        if (response.success===true){
            console.log("Table", response)
            setBuildingList(response?.data);
            setLoading(false);
        }else{
            toast.error("Something went wrong");
            setLoading(false);
        }

    } catch (error) {
        console.log(error);
        setLoading(false);
        const auth = localStorage.getItem("userData");
            const myUserData = JSON.parse(auth);
            const bodyError = { 
              "userId": myUserData?.userId,
              "mobileNumber": myUserData?.mobileNumber,
              "requestJSON": null,
              "uri": "/api/Master/Building",
              "errorNumber": "GB01",
              "errorSource": ErrorSource,
              "errorSummary": error.message,
              "errorDescription": error.message,
              "fileClassName": "tower.js",
              "functionName": "GetBuildingList",
        };
        let response = await commonAPI("ErrorLogMaster", bodyError);
        console.log("statusCode", response);
        if (response?.success == true && response?.message?.length == 0) {
            toast.error("Something went wrong");
            setLoading(false);
        } else {
            setLoading(false);
            toast.error("Something went wrong");
        }
    }

} 

  const GetGroupList = async () => {
        const endPointVariableKey = {
          buildingId: BuildingId
        }

    try {
        setLoading(true);
        let response = await commonAPI("GroupGateLevel", undefined, endPointVariableKey)
        console.log("Table GroupGateLevel", response.data)
        if (response.success===true){
            console.log("Table GroupGateLevel", response)
            setGroupGateList(response?.data);
            setLoading(false);
        }else{
            toast.error("Something went wrong");
            setLoading(false);
        }

    } catch (error) {
        console.log(error);
        setLoading(false);
        const auth = localStorage.getItem("userData");
            const myUserData = JSON.parse(auth);
            const bodyError = { 
              "userId": myUserData?.userId,
              "mobileNumber": myUserData?.mobileNumber,
              "requestJSON": null,
              "uri": "/api/Master/GroupGateLevel",
              "errorNumber": "GB01",
              "errorSource": ErrorSource,
              "errorSummary": error.message,
              "errorDescription": error.message,
              "fileClassName": "tower.js",
              "functionName": "GetBuildingList",
        };
        let response = await commonAPI("ErrorLogMaster", bodyError);
        console.log("statusCode", response);
        if (response?.success == true && response?.message?.length == 0) {
            toast.error("Something went wrong");
            setLoading(false);
        } else {
            setLoading(false);
            toast.error("Something went wrong");
        }
    }

  } 

  useEffect(() => {        
    (async function(){
        const BuildingAuth = localStorage?.getItem("BuildingId");
        const myBuildingId = JSON.parse(BuildingAuth);
        setBuildingId(myBuildingId);
    })()
  }, [])

 

  

  const GetAccessControlType = async () => {
    try {
      console.log("it is run")
      const auth = localStorage.getItem("userData");
      const myUserData = JSON.parse(auth);
      setUserData(myUserData);
      setLoading(true);
      
        const endPointVariableKey    = {
          urlVariable:null,
          buildingId: BuildingId
      
        }
        let response = await commonAPI("AccessControlType", undefined, endPointVariableKey)
        console.log("AccessControlType", BuildingId, response );
        if (response?.success === true) {
          // console.log("AccessControlType", response);
          setAccessControl(response.data);
          setLoading(false);
        } else {
          toast.error("Something went wrong");
          setLoading(false);
        }
      
    } catch (error) {
      console.log(error);
      setLoading(false);
      const bodyError = { 
          "userId": UserData?.userId,
          "mobileNumber": UserData?.mobileNumber,
          "requestJSON": null,
          "uri": "AccessControlType",
          "errorNumber": "GL01",
          "errorSource": ErrorSource,
          "errorSummary": error.message,
          "errorDescription": error.message,
          "fileClassName": "Gate.js",
          "functionName": "GetAccessControlType",
      };
      let response = await commonAPI("ErrorLogMaster", bodyError);
      console.log("statusCode", response);
        setLoading(false);
        toast.error("Something went wrong");
    }
  };


  const GetApplicationList = async () => {
    
        
    try {
        setLoading(true);
         const endPointVariableKey = {
              urlVariable: null,
              buildingId: BuildingId
          }
          let response = await commonAPI("AppSettings", undefined, endPointVariableKey);
          console.log("AppSettings", response);
          if (response?.success === true) {
            console.log("Table AppSettings", response.data)
            const accessControlModuleEnable = response?.data.find(item => item.key === 'ACCESS_CONTROL_MODULE_ENABLE')?.value;
            const AntiPassbackenabled = response?.data.find(item => item.key === 'ANTI_PASSBACK_FEATURE_ENABLE')?.value;
            setAccessenable(parseInt(accessControlModuleEnable));
            setAntiPassbackEnable(parseInt(AntiPassbackenabled));
            setLoading(false);
          } else {
            toast.error("Something went wrong");
            setLoading(false);
          }

    } catch (error) {
        console.log(error);
        setLoading(false);
        const auth = localStorage.getItem("userData");
            const myUserData = JSON.parse(auth);
            const bodyError = { 
              "userId": myUserData?.userId,
              "mobileNumber": myUserData?.mobileNumber,
              "requestJSON": null,
              "uri": "/api/Master/Building",
              "errorNumber": "GB01",
              "errorSource": ErrorSource,
              "errorSummary": error.message,
              "errorDescription": error.message,
              "fileClassName": "tower.js",
              "functionName": "GetBuildingList",
        };
        let response = await commonAPI("ErrorLogMaster", bodyError);
        console.log("statusCode", response);
            setLoading(false);
            toast.error("Something went wrong");
    }

  } 

  const SelectAntiPassBack = async (item, e) => {
    console.log("event is", e.target.checked)
    const auth = localStorage.getItem("userData");
    const myUserData = JSON.parse(auth);
    const bodyData = {
        "gateId": parseInt(item?.gateId),
        // "isAntiPassBackEnabled": item?.isAntiPassBackEnabled == false || item?.isAntiPassBackEnabled == null ? true : false,
        "isAntiPassBackEnabled": e.target.checked,
        "modifiedUserId": myUserData?.userId?.toString()
    };
    try {
        setLoading(true);
        console.log("body", bodyData);
        const BuildingAuth = localStorage.getItem("BuildingId");
        const myBuildingId = JSON.parse(BuildingAuth);
        const endPointVariableKey    = {
          urlVariable:null,
          buildingId: myBuildingId
        }
        let response = await commonAPI("AntiPassback", bodyData, endPointVariableKey)
        console.log("AntiPassback", response);
        if (response.success == true && response.message.length == 0) {
            toast.success("AntiPassback Changed");
            setLoading(false);
            const auth = localStorage.getItem("userData");
            const myUserData = JSON.parse(auth);
            setUserData(myUserData);
            setLoading(true);
            
            const endPointVariableKey = {
              urlVariable: null,
              buildingId: BuildingId
            };

            setTimeout(async () => {
              let response = await commonAPI("Gate", undefined, endPointVariableKey);
              if (response?.success === true) {
                console.log("Table", response);

                setGateList(response.data);
                console.log("body GateList changes", response.data);
                setLoading(false);
              } else {
                toast.error("Something went wrong");
                setLoading(false);
              }
            }, 3000); // Delay execution by 5 seconds
        } else {
            setLoading(false);
            toast.error(response.message[0]);
        }


    } catch (error) {
        console.log(error);
        setLoading(false);
        const bodyError = {
            "userId": myUserData?.userId,
            "mobileNumber": myUserData?.mobileNumber,
            "requestJSON": bodyData,
            "uri": "/api/User/ResetResiding",
            "errorNumber": "PU01",
            "errorSource": ErrorSource,
            "errorSummary": error.message,
            "errorDescription": error.message,
            "fileClassName": "Resident.js",
            "functionName": "SelectResiding",
        };
        let response = await commonAPI("ErrorLogMaster", bodyError);
        console.log("statusCode", response);
        if (response.success == true && response.message.length == 0) {
            toast.error("Something went wrong");
            setLoading(false);
        } else {
            setLoading(false);
            toast.error("Something went wrong");
        }
    }



}

  const GetGateList = async () => {
    try {
      console.log("it is run")
      const auth = localStorage.getItem("userData");
      const myUserData = JSON.parse(auth);
      setUserData(myUserData);
      setLoading(true);
      
        const endPointVariableKey    = {
          urlVariable:null,
          buildingId: BuildingId
      
        }
        let response = await commonAPI("Gate", undefined, endPointVariableKey)
        if (response?.success === true) {
          console.log("Table", response);
          setGateList(response.data);
          setLoading(false);
        } else {
          toast.error("Something went wrong");
          setLoading(false);
        }
      
    } catch (error) {
      console.log(error);
      setLoading(false);
      const bodyError = { 
          "userId": UserData?.userId,
          "mobileNumber": UserData?.mobileNumber,
          "requestJSON": null,
          "uri": "api/Master/Gate",
          "errorNumber": "GL01",
          "errorSource": ErrorSource,
          "errorSummary": error.message,
          "errorDescription": error.message,
          "fileClassName": "Gate.js",
          "functionName": "GetGateList",
      };
      let response = await commonAPI("ErrorLogMaster", bodyError);
      console.log("statusCode", response);
      if (response?.success == true && response?.message?.length == 0) {
          toast.error("Something went wrong");
          setLoading(false);
      } else {
          setLoading(false);
          toast.error("Something went wrong");
      }
    }
  };

  useEffect(() => {
    GetBuildingList();
  }, []);

  useEffect(() => {
    if(BuildingId){
      GetAccessControlType();
      GetGroupList();
    }  
  }, [BuildingId]);

  useEffect(() => {
    if(BuildingId){
      GetApplicationList();
    }  
  }, [BuildingId]);

  useEffect(() => {
    if(BuildingId){
      GetGateList();
      localStorage.setItem("BuildingId", BuildingId?.toString());
    }else if (BuildingId == ""){
      setGateList("")
    }
  }, [BuildingId]);

  

  useEffect(() => {
    if (GateList && AccessControl) {
      setOptionsAccess(
        AccessControl.map((item) => ({
          value: item?.accessTypeId,
          label: item?.accessType,
        }))
      );
    }
  }, [GateList, AccessControl]);

 
    const calculateProduct = () => {
      return selectedOptions.reduce((acc, option) => acc * option.value, 1); // Multiply all selected values
  };

  const isPrime = (num) => {
    if (num <= 1) return false; // Numbers less than or equal to 1 are not prime
    if (num <= 3) return true; // 2 and 3 are prime numbers

    // Check for even numbers and multiples of 3
    if (num % 2 === 0 || num % 3 === 0) return false;

    // Check for factors from 5 to the square root of num
    for (let i = 5; i * i <= num; i += 6) {
        if (num % i === 0 || num % (i + 2) === 0) return false;
    }

    return true; // If no factors were found, num is prime
  };

  // Function to find factors of a given product
  const findFactors = (product) => {
    const factors = [];
    for (let i = 1; i <= Math.sqrt(product); i++) {
        if (product % i === 0) {
            factors.push(i); // i is a factor
            if (i !== product / i) {
                factors.push(product / i); // product / i is also a factor
            }
        }
    }
    return factors;
  };

  useEffect(() => {
    if (MultiValue === 0) {
      setSelectedOptions([]);
    } else {
      const product = MultiValue; // The calculated product from MultiValue
      const factors = findFactors(product);
      const primeFactors = factors.filter(isPrime);
      
      // Find the options that match the prime factors
      const autoSelectedOptions = optionsAccess.filter(option => primeFactors.includes(option.value));
      
      // Set the selected options
      setSelectedOptions(autoSelectedOptions);
    }
  }, [MultiValue, optionsAccess]);


 

  console.log("calculateProduct", calculateProduct())

  const AddGateData = async () => {
    const bodyData = {
      gateIP: GateIp,
      gateName: GateName,
      portNumber: PortNumber,
      pin: Pin == "" ? 0 : parseInt(Pin),
      barrierOperateTime: BarrierOperate == "" ? 0 : parseInt(BarrierOperate),
      signalLightTime: SignalLight == "" ? 0 : parseInt(SignalLight),
      gateType: GateType,
      gateSubType: GateSubType,
      accessType: AccessType,
      isOperable: IsOperable,
      isCascadable: IsCascadable,
      isMainGate: IsMainGate,
      accessControlPrimeFactor: Accessenable === 1 
        ? (GateSubType == "WALKIN" ? (calculateProduct() || 0) : 0)
        : null,
      levelId: parseInt(GroupGateId),
      createdUserId: JSON.stringify(UserData?.userId), 
    };
    try {
      setLoading(true);
      const auth = localStorage.getItem("userData");
      const myUserData = JSON.parse(auth);
      setUserData(myUserData);
      const BuildingAuth = localStorage.getItem("BuildingId");
      const myBuildingId = JSON.parse(BuildingAuth);
      const endPointVariableKey    = {
        urlVariable:null,
        buildingId: myBuildingId
    
      }
      if(!GateName){
        toast.warning("Please enter Gate Name");
        setLoading(false);
      }else if (!GateIp){
        toast.warning("Please enter Gate IP");
        setLoading(false);      
      }else if (!GateType){
          toast.warning("Please select Gate Type");
          setLoading(false);
      }else if(!GateSubType){
          toast.warning("Please select Gate Sub Type");             
          setLoading(false);
      }else{
        console.log("bodyGate", bodyData);
        let response = await commonAPI("GateAdd", bodyData, endPointVariableKey)
        console.log("GateResponse", response);
        if (response?.success === true && response?.message?.length == 0) {
          setLoading(false);
          toast.success("Gate Added");
          setShow(false);
          GetGateList();
        } else {
          setLoading(false);
          toast.error(response?.message[0]);
        }
      }  
    } catch (error) {
      console.log(error);
      setLoading(false);
      const bodyError = { 
          "userId": UserData?.userId,
          "mobileNumber": UserData?.mobileNumber,
          "requestJSON": bodyData,
          "uri": "api/Master/Gate",
          "errorNumber": "GA01",
          "errorSource": ErrorSource,
          "errorSummary": error.message,
          "errorDescription": error.message,
          "fileClassName": "Gate.js",
          "functionName": "AddGateData",
      };
      // let response = await commonAPI("GateAdd", bodydata, endPointVariableKey)
      let response = await commonAPI("ErrorLogMaster", bodyError);
      console.log("statusCode", response);
      if (response?.success == true && response?.message?.length == 0) {
          toast.error("Something went wrong");
          setLoading(false);
      } else {
          setLoading(false);
          toast.error("Something went wrong");
      }
    }
    
  };

  const UpdateGateDate = async () => {
    const bodyData = {
      gateId: GateId,
      gateIP: GateIp,
      gateName: GateName,
      portNumber: PortNumber,
      pin: Pin == "" ? 0 : Pin,
      barrierOperateTime: BarrierOperate == "" ? 0 : BarrierOperate,
      signalLightTime: SignalLight == "" ? 0 : SignalLight,
      gateType: GateType,
      gateSubType: GateSubType,
      accessType: AccessType,
      isOperable: IsOperable,
      isCascadable: IsCascadable,
      isMainGate: IsMainGate,
      accessControlPrimeFactor: Accessenable === 1 
        ? (GateSubType === "WALKIN" ? (calculateProduct() || 0) : 0)
        : null,
      levelId: parseInt(GroupGateId),
      modifiedUserId: JSON.stringify(UserData?.userId),
    };
    try {
      setLoading(true);
      const auth = localStorage.getItem("userData");
      const myUserData = JSON.parse(auth);
      setUserData(myUserData);
      setLoading(true);
      const BuildingAuth = localStorage.getItem("BuildingId");
      const myBuildingId = JSON.parse(BuildingAuth);
      const endPointVariableKey    = {
        urlVariable:null,
        buildingId: myBuildingId
    
      }
      console.log("body", bodyData);
      if(!GateName){
        toast.warning("Please enter Gate Name");
        setLoading(false);
      }else if (!GateIp){
        toast.warning("Please enter Gate IP");
        setLoading(false);      
      }else if (!GateType){
          toast.warning("Please select Gate Type");
          setLoading(false);
      }else if(!GateSubType){
          toast.warning("Please select Gate Sub Type");             
          setLoading(false);
      }else{
        let response = await commonAPI("GateUpdate", bodyData, endPointVariableKey)
        
        console.log("statusCode", response);
        if (response?.success === true && response?.message?.length == 0 ) {
          toast.success("Gate Updated");
          setLoading(false);
          setShow(false);
          GetGateList();
        } else {
          toast.error(response.message[0]);
          setLoading(false);
        }
      }  
      
    } catch (error) {
      console.log(error);
      setLoading(false);
      const bodyError = JSON.stringify({ 
          "userId": UserData?.userId,
          "mobileNumber": UserData?.mobileNumber,
          "requestJSON": bodyData,
          "uri": "api/Master/Gate/",
          "errorNumber": "UG01",
          "errorSource": "CuroNextPortal",
          "errorSummary": error.message,
          "errorDescription": error.message,
          "fileClassName": "Gate.js",
          "functionName": "UpdateGateData",
      });
      let response = await commonAPI("ErrorLogMaster", bodyError);
      console.log("statusCode", response);
      if (response?.success == true && response?.message?.length == 0) {
          toast.error("Something went wrong");
          setLoading(false);
      } else {
          setLoading(false);
          toast.error("Something went wrong");
      }
    }
    
  };

  const ShowDeleteModal = (item) => {
    setDeleteShow(true);
    setSelectedGateId(item)

  }

  const DeleteGate = async () => {
    let bodyData = {
      gateId: SelectedGateId?.gateId,
      modifiedUserId: JSON.stringify(UserData.userId), 
    };
    try {
      setLoading(true);
      const auth = localStorage.getItem("userData");
      const myUserData = JSON.parse(auth);
      setUserData(myUserData);
      setLoading(true);
      const BuildingAuth = localStorage.getItem("BuildingId");
      const myBuildingId = JSON.parse(BuildingAuth);
      const endPointVariableKey    = {
        urlVariable:null,
        buildingId: myBuildingId
    
      }
      console.log("body", bodyData);
      let response = await commonAPI("GateDelete", bodyData, endPointVariableKey)
      console.log("statusCode", response);
      if (response?.success === true && response?.message?.length == 0) {
        toast.success("Gate Deleted");
        setLoading(false);
        setDeleteShow(false);
        GetGateList();
      } else {
        toast.error(response.message[0]);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
      const bodyError = { 
          "userId": UserData?.userId,
          "mobileNumber": UserData?.mobileNumber,
          "requestJSON": bodyData,
          "uri": "api/Master/Gate",
          "errorNumber": "DG01",
          "errorSource": ErrorSource,
          "errorSummary": error.message,
          "errorDescription": error.message,
          "fileClassName": "Gate.js",
          "functionName": "DeleteGate",
      };
      let response = await commonAPI("ErrorLogMaster", bodyError);
      console.log("statusCode", response);
      if (response.success == true && response.message.length == 0) {
          toast.error("Something went wrong");
          setLoading(false);
      } else {
          setLoading(false);
          toast.error("Something went wrong");
      }
    }
  };

  

  

  const handleChangeOperateTime = (e) => {
    let value = e.target.value;

    // Ensure the value is a positive number or empty (for when input is cleared)
    if (value === "" || (Number(value) >= 0 && !value.startsWith('-'))) {
      setBarrierOperate(value);
    }
  };

  
  

  return (
    <>
      {Loading? 
        <div className="loaderDiv">
          <div className="loader"></div>
        </div> 
      :null}
      {/* <Menus />  */}
      <ToastContainer />
      <div className="row mt-5 pt-5" style={{alignItem:'center'}}>
            <div className="col-lg-6 col-md-6">
                <div className="HeadingTop">
                    <h3> Gates </h3>
                    <span> Configure and oversee the entry and exit gates of the society.</span>
                </div>
            </div>
            <div className="col-lg-6 col-md-6  text-right" style={{alignContent:'center'}}>
              <select size="md" className="sltareamodal col-4 ml-auto" value={BuildingId}  onChange={(e) => {
                console.log("selection", e.target.value)
                setBuildingId(e.target.value);}}>
                <option value="">Select Building</option>
                {BuildingList ? BuildingList?.map((item, index) =>  <option key={index} value={item.buildingId}>{item.buildingName}</option>): null}
              </select>
              <button
                type="button"
                className="btn btn-info"
                onClick={() => openCreateModal()}
              >
                <FontAwesomeIcon icon={faPlus} /> Create New
              </button> 
            </div>
        </div>
 

        <Modal size="md" show={show} onHide={() => setShow(false)} className="modal-100w modal-md clientmodal right text-end p-0" aria-labelledby="contained-modal-title-vcenter " >
            <Modal.Header closeButton className="headerMDL">
              <Modal.Title id="example-modal-sizes-title-lg">
                {/* Add Gate */}
                {UpdateGateBtn ?   <>Update Gate</> : <>Add Gate</> }
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="helpingElelemnt_uuy002">
          
           
              <div className="row" id="validation">
              <div className="col-12">
              <div className="card-body p-0">
          
                      <form
                        action="#"
                        className="validation-wizard wizard-circle wizard clearfix"
                        role="application"
                        id="steps-uid-0"
                        novalidate="novalidate"
                      >
                            <div className="content clearfix">
                                     
                                    
                                     <section id="steps-uid-2-p-0" role="tabpanel" aria-labelledby="steps-uid-2-h-0" className="body current pt-2" aria-hidden="false">
                        <div className="row text-left">
                          <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                            <div className="row">
                              <div className="col-md-6 mb-2">
                                <div className="form-group">
                                  <label for="wfirstName2">
                                    {" "}
                                    Gate Name  <span className="danger">*</span>{" "}
                                  </label>
                                  <input
                                    type="text"
                                    value={GateName}
                                    onChange={(e) => {
                                      setGateName(e.target.value);
                                    }}
                                    className="form-control required"
                                    id="wfirstName2"
                                    name="firstName"
                                    aria-required="true"
                                  />
                                </div>
                              </div>
                              <div className="col-md-6 mb-2">
                                <div className="form-group">
                                  <label for="wlastName2">
                                    {" "}
                                    Gate IP  <span className="danger">*</span>{" "}
                                  </label>
                                  <input
                                    type="text"
                                    value={GateIp}
                                    className="form-control required"
                                    onChange={(e) => {
                                      setGateIp(e.target.value);
                                    }}
                                    id="wlastName2"
                                    name="lastName"
                                    aria-required="true"
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-md-6 mb-2">
                                <div className="form-group">
                                  <label for="wfirstName2">
                                    {" "}
                                    Port Number {" "}
                                  </label>
                                  <input
                                    type="text"
                                    value={PortNumber}
                                    onChange={(e) => {
                                      setPortNumber(e.target.value);
                                    }}
                                    className="form-control required"
                                    id="wfirstName2"
                                    name="firstName"
                                    aria-required="true"
                                  />
                                </div>
                              </div>
                              <div className="col-md-6 mb-2">
                                <div className="form-group">
                                  <label for="webUrl3">Is MainGate</label>
                                  <Form.Select size="md" className="sltareamodal" value={IsMainGate} onChange={(e) => {e.target.value=="true"?setIsMainGate(true):setIsMainGate(false);}}>
                                    {/* {IsMainGate ? <option value={IsMainGate}>{IsMainGate == true ? <>Yes</>:<>No</>}</option> :<option value={true}> Yes </option>} */}
                                    <option value={true}> Yes </option>
                                    <option value={false}> No</option>
                                  </Form.Select>
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-md-6 mb-2">
                                <div className="form-group">
                                  <label for="jobTitle2">Pin</label>
                                  <input
                                    type="text"
                                    value={Pin}
                                    onChange={(e) => setPin(e.target.value)}
                                    className="form-control required"
                                    id="jobTitle2"
                                    aria-required="true"
                                  />
                                </div>
                              </div>
                              <div className="col-md-6 mb-2">
                                <div className="form-group">
                                  <label for="webUrl3">Barrier Operate Time </label>
                                  <input
                                    type="number"
                                    value={BarrierOperate}
                                    onChange={(e) => {handleChangeOperateTime(e)}}
                                    className="form-control required"
                                    id="webUrl3"
                                    name="webUrl3"
                                    aria-required="true"
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-md-6 mb-2">
                                <div className="form-group">
                                  <label for="webUrl3">Signal Light Time  </label>
                                  <input
                                    type="url"
                                    value={SignalLight}
                                    onChange={(e) => setSignalLight(e.target.value)}
                                    className="form-control required"
                                    id="webUrl3"
                                    name="webUrl3"
                                    aria-required="true"
                                  />
                                </div>
                              </div>
                              <div className="col-md-6 mb-2">
                                <div className="form-group">
                                  <label for="webUrl3">Access Type</label>
                                  <Form.Select
                                    size="md"
                                    className="sltareamodal"
                                    value={AccessType}
                                    onChange={(e) => setAccessType(e.target.value)}
                                  >
                                    {/* {AccessType ? <option value={AccessType}>{AccessType}</option> :<option value={"Public"}> Public </option>} */}
                                    <option value={"PUBLIC"}> Public </option>
                                    <option value={"PRIVATE"}> Private</option>
                                    <option value={"RESTRICTED"}> Restricted</option>
                                  </Form.Select>
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-md-6 mb-2">
                                <div className="form-group">
                                  <label for="webUrl3">Gate Type </label>
                                  <Form.Select
                                    size="md"
                                    className="sltareamodal"
                                    value={GateType}
                                    onChange={(e) => setGateType(e.target.value)}
                                  >
                                    {/* {GateType ? <option value={GateType}>{GateType}</option> :} */}
                                    <option value={"Entry"}> Entry </option>
                                    <option value={"Exit"}> Exit</option>
                                  </Form.Select>
                                </div>
                              </div>
                              <div className="col-md-6 mb-2">
                                <div className="form-group">
                                  <label for="jobTitle2">Gate Sub type</label>
                                  <Form.Select
                                    size="md"
                                    className="sltareamodal"
                                    value={GateSubType}
                                    onChange={(e) => {setGateSubType(e.target.value); setSelectedOptions([]); setGroupGateId("");}}
                                  >
                                    {/* {GateSubType ? <option value={GateSubType}>{GateSubType}</option> :} */}
                                    <option value={"4WHEELER"}> 4 Wheeler </option>
                                    <option value={"2WHEELER"}> 2 Wheeler</option>
                                    <option value={"WALKIN"}> Walk-In</option>
                                  </Form.Select>
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-md-6 mb-2">
                                <div className="form-group">
                                  <label for="webUrl3">Is Operable</label>
                                  <Form.Select
                                    size="md"
                                    className="sltareamodal"
                                    value={IsOperable}
                                    onChange={(e) => {e.target.value=="true"?setIsOperable(true):setIsOperable(false);}}
                                  >
                                    <option value={true}> Yes </option>
                                    <option value={false}> No</option>
                                  </Form.Select>
                                </div>
                              </div>
                              <div className="col-md-6 mb-2">
                                <div className="form-group">
                                  <label for="webUrl3">Is Cascadable </label>
                                  <Form.Select
                                    size="md"
                                    className="sltareamodal"
                                    value={IsCascadable}
                                    onChange={(e) => {e.target.value=="true"?setIsCascadable(true):setIsCascadable(false);}}
                                  >
                                    <option value={true}> Yes </option>
                                    <option value={false}> No</option>
                                  </Form.Select>
                                </div>
                              </div>
                              {GateSubType == "WALKIN" && (
                                <>
                                  {Accessenable === 1 && (
                                    <>
                                      <div className="col-md-6 mb-5">
                                        <div className="form-group">
                                          <label for="webUrl3">Access Control Type </label>
                                          <Select className="configdrop"
                                          isMulti
                                          value={selectedOptions}
                                          onChange={setSelectedOptions}
                                          options={optionsAccess}
                                          placeholder="All Access"
                                          isClearable
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-6 mb-5">
                                      <div className="form-group">
                                        <label for="webUrl3">Group Gate Level </label>
                                        <Form.Select
                                          size="md"
                                          className="sltareamodal"
                                          value={GroupGateId}
                                          onChange={(e) => setGroupGateId(e.target.value)}
                                        >
                                          <option value="">Select Group Gate Level</option>
                                          {GroupGateList.map((item, index) => (
                                          <option key={index} value={item.levelId}>{item.groupLevelName}</option>
                                          ))}
                                        </Form.Select>
                                      </div>
                                    </div>
                                  </>  
                                  )}
                                </>
                                 )} 
                            </div>  
                          </div>
                        </div> 
                        </section>
                        </div>
                      </form>
                </div>
                </div>
              </div>
            
           
            </Modal.Body>



            <div className="fixed_allbtn" style={{height: 60, padding: 0}}>                        
              <div className="upload_btn">
              <ul role="menu" aria-label="Pagination" className='mb-0'>
              {AddGateBtn ?
                              <div className="  align-self-start">
                                  <button type="button" className="btn border bg-white" onClick={() => setShow(false)}> Cancel</button>
                                  <button type="button" className="btn btn-info" onClick={() => AddGateData()}> Submit</button>
                              </div>
                                // <Button variant="contained" className="next_btn"  onClick={activeStep==steps.length - 1 ?()=>{AddGateData()}:()=>handleNext()}>
                                //     {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                                // </Button>
                            :null} 
                            {UpdateGateBtn ? 
                                <div className="  align-self-start">
                                    <button type="button" className="btn border bg-white" onClick={() => setShow(false)}> Cancel</button>
                                    <button type="button" className="btn btn-info" onClick={() => UpdateGateDate()}> Update</button>
                                </div>
                                
                            :null}
                                    </ul>
                                          </div>
 </div>


          </Modal>

          <div className="row">
            <div className="col-12">
                    <div id="example23_wrapper" className="dataTables_wrapper pt-0">
                      <div className="row">
                      {BuildingId ? (!GateList?.length &&  GateList?.length != null && 
                        <div className='bg-white' style={{paddingBottom:"50px", borderRadius: "10px"}}>
                            <div className='col-12 text-center'>
                                <img src={GateIcon} alt="user" class="mx-auto mt-5" style={{height: "100px"}} />
                            </div>    
                            <br />
                            <h3 className='col-12 text-center NoDataShowTextColor' style={{marginTop: "0px"}}> No Gate found</h3>
                            <h5 className='col-12 text-center NoDataShowTextColor' style={{marginTop: "10px"}}> Click on Create New button to add a Gate</h5>
                        </div>) : null}
                        {GateList
                            ? GateList.map((item, index) => (
                            <div className="col-lg-3 col-md-6 col-sm-12 col-12" key={index}>
                                <div className="clientTiles" style={{height: Accessenable === 1 ? 230 : 200}}>
                                    <div className="ClientImg">
                                        <div className="tabs_img">
                                        <img src={GateIcon} class="img img-responsive" alt="client-img" />
                                        </div>
                                        <div class="bars_font">
                                            <h3 className="font_trigger" onClick={() => {setInputValue(item);}} >
                                                <FontAwesomeIcon icon={faPenToSquare} />
                                            </h3>
                                            <h3 className="font_trigger" onClick={() => {ShowDeleteModal(item);}}>
                                                <FontAwesomeIcon icon={faTrashCan} />
                                            </h3>
                                        </div>
                                    </div>
                                    <div className="ClientText">
                                        <div className="l-two">
                                            <h1>{item.gateIP} </h1>
                                            <h4>{item.gateName} </h4>
                                            <div style={{display: "flex", justifyContent: "space-between"}}>
                                              <h4>{item.gateType} </h4>
                                              {Accessenable === 1 && AntiPassbackEnable === 1 ?
                                                <>
                                                  {item?.accessControlPrimeFactor != null && item?.accessControlPrimeFactor >= 2 && item.gateType.toUpperCase() == "ENTRY"?
                                                    <div style={{display: "flex", justifyContent: "space-between"}}> 
                                                      <h6 className='pt-1 pr-0'>Antipassback : </h6>
                                                      <label className="switch1" style={{marginLeft: "13px"}}>
                                                          <input type="checkbox"  checked={item?.isAntiPassBackEnabled == false || item?.isAntiPassBackEnabled == null ? false : true} onChange={(e) => SelectAntiPassBack(item, e)} />
                                                          <span className="slider1 round1" key={index}></span>
                                                      </label>
                                                    </div>
                                                   :null} 
                                                </>  
                                              :null}   
                                            </div>
                                            <h4>{item.gateSubType}</h4>
                                        </div>
                                    </div>
                                    {Accessenable === 1 ?
                                      <div style={{display: "flex", justifyContent: "space-between"}}>
                                        {item.accessControlPrimeFactor != null && item.accessControlPrimeFactor !== 0 ? (
                                          <>
                                          {item.accessControlPrimeFactor % 2 === 0 && (
                                            // <span>
                                              <img src={FrIcon} style={{width: 25}} alt="Gate Icon" className="img-fluid" />
                                            // </span>
                                          )}
                                          {item.accessControlPrimeFactor % 3 === 0 && (
                                            // <span>
                                              <img src={QrIcon} style={{width: 25}} alt="Gate Icon" className="img-fluid" />
                                            // </span>
                                          )}
                                          {item.accessControlPrimeFactor % 5 === 0 && (
                                            // <span>
                                              <img src={TagIcon} style={{width: 25}} alt="Gate Icon" className="img-fluid" />
                                            // </span>
                                          )}
                                          </>
                                        ) : null}
                                      </div>
                                    :null}  
                                </div>
                            </div>
                            ))
                            : null}
                        </div>
                    </div>
                   
                 
            </div>
          </div>
          
            <Modal centered show={DeleteShow} onHide={() =>
          setDeleteShow(false)} dialogclassName="modal-100w" aria-labelledby="contained-modal-title-vcenter ">
              {/* <Modal.Header className="headerMDL" closeButton>
                  <Modal.Title id="contained-modal-title-vcenter" centered onClick={openCreateModal}>
                      <h4 className="mb-0"> Delete Gate </h4>
                  </Modal.Title>
              </Modal.Header> */}
              <Modal.Body className='p-0' style={{borderRadius: "10px", overflow: "hidden"}}>
                    <div className="row px-3" id="validation">
                        <div className="col-12 bg-white pt-3 pb-2">
                            <div className="FnFItem" style={{justifyContent: "flex-start"}}>
                            {/* <div className="FnFimg">
                                <img src={stopMark} className='img img-fluid img-responsive'  alt="placeholder" />
                            </div> */}
                            <div className="FnFtxt">
                                <h2> Delete Gate  </h2>
                                <h3> Are you sure you want to delete? </h3>
                            </div>
                            </div>
                            
                        </div>
                        
                    </div>
                    <div className='confirmation_btn pb-4 pt-3 px-3' style={{justifyContent: "center", borderTop: "1px solid #dadada"}}>
                            <div className='both_ConfrmBTN col-6' onClick={DeleteGate}>
                                <Button variant="danger">Delete</Button>{' '}
                            </div>
                            <div className='both_ConfrmBTN col-6' onClick={() => setDeleteShow(false)} >
                                <Button variant="light"> Cancel</Button>{' '}
                            </div>
                        </div>
                </Modal.Body>
            </Modal>          
    </>
  );
}
export default Gate; 
